import React from "react";
import TypeSelector from "./typeSelectors/TypeSelector";
import TaskTypeSelector from "./typeSelectors/TaskTypeSelector";
import ColorTypeSelector from "./typeSelectors/ColorTypeSelector";
import ItemNameInput from "./ItemNameInput";
import DayRow from "./DayRow";
import TimeRow from "./TimeRow";
import DescriptionRow from "./DescriptionRow";
import ChecklistButton from "./ChecklistButton";
import DeleteButton from "./DeleteButton";

export default function ItemDetails(props) {
  const {
    itemType,
    setItemType,
    itemDone,
    setItemDone,
    itemName,
    setItemName,
    itemTime,
    setItemTime,
    itemHasChecklist,
    setItemHasChecklist,
    setOpenChecklist,
    itemId,
    handleDeleteClick,
    appointmentDuration,
    setAppointmentDuration,
    itemDescription,
    setItemDescription,
    taskType,
    setTaskType,
    colorType,
    setColorType,
    itemDay,
    setItemDay,
    activeDate,
    setActiveDate,
    dateHelper,
  } = props;
  function secondarySelector() {
    switch (itemType) {
      case "task":
        return (
          <TaskTypeSelector
            taskType={taskType}
            setTaskType={setTaskType}
            itemDay={itemDay}
            setItemDay={setItemDay}
            activeDate={activeDate}
            setActiveDate={setActiveDate}
            dateHelper={dateHelper}
          />
        );
      case "calendar_note":
        return (
          <ColorTypeSelector
            colorType={colorType}
            setColorType={setColorType}
            itemDay={itemDay}
          />
        );
      case "appointment":
        return <div className="row-separator-full"></div>;
    }
  }

  return (
    <div className="Item-details">
      <TypeSelector itemType={itemType} setItemType={setItemType} />
      <ItemNameInput
        itemName={itemName}
        setItemName={setItemName}
        itemDone={itemDone}
        setItemDone={setItemDone}
        itemType={itemType}
        taskType={taskType}
        setOpenChecklist={setOpenChecklist}
        itemId={itemId}
        itemHasChecklist={itemHasChecklist}
      />
      {secondarySelector()}
      <DayRow
        activeDate={activeDate}
        itemDay={itemDay}
        itemType={itemType}
        taskType={taskType}
        dateHelper={dateHelper}
        colorType={colorType}
      />
      {itemType !== "calendar_note" && (
        <TimeRow
          itemType={itemType}
          taskType={taskType}
          itemTime={itemTime}
          setItemTime={setItemTime}
          appointmentDuration={appointmentDuration}
          setAppointmentDuration={setAppointmentDuration}
        />
      )}
      <div className="row-separator-full space-above" />
      <DescriptionRow
        itemDescription={itemDescription}
        setItemDescription={setItemDescription}
      />
      {itemType !== "calendar_note" && (
        <ChecklistButton
          {...{ itemId, setOpenChecklist }}
          itemHasChecklist={itemHasChecklist}
          setItemHasChecklist={setItemHasChecklist}
        />
      )}
      <DeleteButton handleDeleteClick={handleDeleteClick} />
    </div>
  );
}
